import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "OpSearchTree",
  props: {
    data: {
      type: Array,
      required: true,
      default: null
    },
    showCheckbox: {
      type: Boolean,
      required: false,
      default: false
    },
    defaultProps: {
      type: Object,
      required: false,
      default: function _default() {
        return {
          children: 'children',
          label: 'name'
        };
      }
    }
  },
  data: function data() {
    return {
      filterText: '',
      checkedNodes: [],
      checkedNodeId: "",
      isShowDown: false
    };
  },
  watch: {
    filterText: function filterText(val) {
      this.$refs.tree.filter(val);
    },
    checkedNodeId: function checkedNodeId() {
      this.$emit('input', this.checkedNodeId);
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.$refs['tree'].setCurrentKey("1272798412358885377");
    });
  },
  methods: {
    filterNode: function filterNode(value, data) {
      if (!value) return true;
      return data[this.defaultProps.label].indexOf(value) !== -1;
    },
    getCheckedKeys: function getCheckedKeys(e) {
      var _this = this;
      this.checkedNodes = [];
      if (this.showCheckbox) {
        var arr = [];
        var nodes = this.$refs.tree.getCheckedNodes();
        nodes.forEach(function (item) {
          if (!item.children) {
            var obj = {
              name: item[_this.defaultProps.label],
              id: item.id
            };
            _this.checkedNodes.push(obj);
            arr.push(item.id);
            _this.checkedNodeId = arr.join(",");
          }
        });
      } else {
        var obj = {
          name: e[this.defaultProps.label],
          id: e.id
        };
        this.checkedNodes.push(obj);
        this.checkedNodeId = e.id;
      }
    },
    deleteNode: function deleteNode(index, id) {
      var _this2 = this;
      this.checkedNodes.splice(index, 1);
      var arr = [];
      if (this.checkedNodes.length > 1) {
        this.checkedNodes.forEach(function (item) {
          arr.push(item.id);
          _this2.checkedNodeId = arr.join(",");
        });
      } else {
        this.checkedNodeId = "";
      }
      this.$refs.tree.setChecked(id, false, true);
    },
    showDown: function showDown() {
      this.isShowDown = !this.isShowDown;
    }
  }
};